import React, { useState } from 'react'
import { Card, CardContent, CardHeader, Grid, ToggleButton, ToggleButtonGroup } from '@mui/material'
import { DualAxisChart } from '../../../charts/CompositChart'
import { ADHERENCE_COLORS } from '../../../charts/colors'
import InfoBox from '../../../../common/InfoBox'
import { formatNumber, numberPrecision } from '../../../../helpers/UtilityHelper'
import useGetCourier from '../useGetCourier'
import _ from 'lodash'

const RtoForwardDeliveryAnalysis = ({ data = [] }) => {
    const [view, setView] = useState('percentage')
    const { data: allCouriers } = useGetCourier()

    if (!data || data.length === 0) return null

    const enrichedData = data.map(row => {
        const courier = _.find(allCouriers, { id: row.name })
        return { ...row, name: courier ? courier.parent : row.name }
    })

    const totalWithinSLA = _.sumBy(enrichedData, 'firstAttemptWithinSLA')
    const totalNotWithinSLA = _.sumBy(enrichedData, 'firstAttemptNotWithinSLA')
    const total = totalWithinSLA + totalNotWithinSLA

    const dataKey1 = view === 'percentage' ? 'firstAttemptWithinSLAPercentage' : 'firstAttemptWithinSLA'
    const dataKey2 = view === 'percentage' ? 'firstAttemptNotWithinSLAPercentage' : 'firstAttemptNotWithinSLA'

    const chartOptions = {
        layout: 'horizontal',
        xaxis: 'name',
        showLabels: true,
        legendAlign: 'left',
        yaxis: {
            left: {
                label: view === 'percentage' ? 'Percentage' : 'Count',
                data: [
                    { dataKey: dataKey1, label: 'Within SLA', chartType: 'bar', fill: ADHERENCE_COLORS.WITHIN },
                    { dataKey: dataKey2, label: 'Not Within SLA', chartType: 'bar', fill: ADHERENCE_COLORS.NOT_WITHIN },
                ],
            },
        },
    }

    return (
        <Card elevation={1}>
            <CardHeader
                title="RTO — First Forward Delivery Attempt SLA"
                subheader="For RTO shipments, whether the first delivery attempt was within the promised SLA"
                action={
                    <ToggleButtonGroup value={view} exclusive size="small" onChange={(_e, v) => v && setView(v)}>
                        <ToggleButton value="percentage">%</ToggleButton>
                        <ToggleButton value="count">Count</ToggleButton>
                    </ToggleButtonGroup>
                }
            />
            <CardContent>
                <Grid container spacing={1} sx={{ mb: 2 }}>
                    <Grid item xs={4}>
                        <InfoBox header="Within SLA" value={`${formatNumber(totalWithinSLA)} (${numberPrecision((totalWithinSLA / total) * 100)}%)`} />
                    </Grid>
                    <Grid item xs={4}>
                        <InfoBox header="Not Within SLA" value={`${formatNumber(totalNotWithinSLA)} (${numberPrecision((totalNotWithinSLA / total) * 100)}%)`} />
                    </Grid>
                    <Grid item xs={4}>
                        <InfoBox header="Total" value={formatNumber(total)} />
                    </Grid>
                </Grid>
                <DualAxisChart data={enrichedData} chartOptions={chartOptions} />
            </CardContent>
        </Card>
    )
}

export default RtoForwardDeliveryAnalysis
